import React, { lazy } from 'react'
import { Route, Routes } from "react-router-dom";
import Layout from "./Layout/Layout";



import OnlyRegisterd from "./Layout/OnlyRegisterd";





import PageNotFound from "./pages/PageNotFound/PageNotFound";
import UserDashboard from './pages/UserDashboard/UserDashboard';
import SecretaryDashboard from './pages/SecretaryDashboard/SecretaryDashboard';
import SecretaryMain from './pages/SecretaryDashboard/SecretaryMain/SecretaryMain';
import VerifyAccount from './pages/UserDashboard/VerifyAccount';
import CreateRequest from './pages/UserDashboard/CreateRequest';
import AllRequests from './pages/SecretaryDashboard/AllRequests/AllRequests';
import PendingRequests from './pages/SecretaryDashboard/PendingRequests/PendingRequests';
import AcceptedRequests from './pages/SecretaryDashboard/AcceptedRequests/AcceptedRequests';
import NominatedRequests from './pages/SecretaryDashboard/NominatedRequests/NominatedRequests';
import ApprovedRequests from './pages/SecretaryDashboard/ApprovedRequests/ApprovedRequests';
import ReadyRequests from './pages/SecretaryDashboard/ReadyRequests/ReadyRequests';
import VerificationRequests from './pages/SecretaryDashboard/VerificationRequests/VerificationRequests';
import ManagerDashboard from './pages/ManagerDashboard/ManagerDashboard';
import ManagerStats from './pages/ManagerDashboard/ManagerStats/ManagerStats';
import ManagerAllRequests from './pages/ManagerDashboard/ManagerAllRequests/ManagerAllRequests';
import ManagerNominatedRequests from './pages/ManagerDashboard/ManagerNominatedRequests/ManagerNominatedRequests';
import OrganizationDashboard from './pages/OrganizationDashboard/OrganizationDashboard';
import OrganizationMain from './pages/OrganizationDashboard/OrganizationMain';
import OrganizationGeneralInfo from './pages/OrganizationDashboard/OrganizationGeneralInfo';
import OrganizationVerifyAccount from './pages/OrganizationDashboard/OrganizationVerifyAccount';
import OrganizationCreateRequest from './pages/OrganizationDashboard/OrganizationCreateRequest';
import OrganizationUpdatePassword from './pages/OrganizationDashboard/OrganizationUpdatePassword';
import CreateReport from './pages/OrganizationDashboard/CreateReport';
import OrganizationReports from './pages/OrganizationDashboard/OrganizationReports';
import AllOrgRequests from './pages/SecretaryDashboard/AllOrgRequests/AllOrgRequests';
import ManagerAllOrgRequests from './pages/ManagerDashboard/ManagerAllOrgRequests/ManagerAllOrgRequests';
import EditProfile from './pages/EditProfile/EditProfile';
import UpdatePassword from './pages/EditProfile/UpdatePassword';
import OrgVerificationRequests from './pages/SecretaryDashboard/OrgVerificationRequests/OrgVerificationRequests';
import AllReports from './pages/AllReports/AllReports';
import NotAuthorized from './pages/NotAuthorized/NotAuthorized';
import Setting from './pages/SecretaryDashboard/Setting/Setting';



const About = lazy(()=>import("./pages/About/About"));

const FAQ = lazy(()=>import("./pages/FAQ/FAQ"));
const ForgotPassword = lazy(()=>import("./pages/ForgotPassword/ForgotPassword"));
const Login = lazy(()=>import("./pages/Login.js/Login"));
const ResetPassword = lazy(()=>import("./pages/ResetPassword/ResetPassword"));
const Signup = lazy(()=>import("./pages/Signup/Signup"));
const SuccessfulPage = lazy(()=>import("./pages/SuccessfulPage/SuccessfulPage"));


const EditUserProfile = lazy(()=>import("./pages/EditUserProfile/EditUserProfile"));



const UserMain = lazy(()=>import("./pages/UserDashboard/UserMain"));

const UserUpdatePassword = lazy(()=>import("./pages/UserDashboard/UserUpdatePassword"));
const UserGeneralInfo = lazy(()=>import("./pages/UserDashboard/UserGeneralInfo"));










function App() {



  return (
    <Routes>


      <Route element={<Layout/>}>
        <Route path="/" element={<Login />}/>
        <Route path="/signup" element={<Signup />}/>
        <Route path="/forgot-password" element={<ForgotPassword />}/>
        <Route path="/reset-password" element={<ResetPassword />}/>
        <Route path="/about" element={<About />}/>

        <Route path="/Faq" element={<FAQ />}/>

        

        <Route path="/successful-page/:type" element={<SuccessfulPage />} />



        


      </Route>

      <Route element={<OnlyRegisterd />}>

        <Route path="/edit-user-profile/:user_id" element={<EditUserProfile />} />


      </Route>


      <Route path="/user-dashboard" element={<UserDashboard />}>
          <Route index element={<UserMain/>}/>
  
          <Route path="general-info" element={<UserGeneralInfo/>}/>
          <Route path="verify-account" element={<VerifyAccount/>}/>
          <Route path="create-request" element={<CreateRequest/>}/>
          <Route path="update-password" element={<UserUpdatePassword/>}/>
      </Route>

      <Route path="/organization-dashboard" element={<OrganizationDashboard />}>
          <Route index element={<OrganizationMain/>}/>
  
          <Route path="general-info" element={<OrganizationGeneralInfo/>}/>
          <Route path="verify-account" element={<OrganizationVerifyAccount/>}/>
          <Route path="create-request" element={<OrganizationCreateRequest/>}/>
          <Route path="reports" element={<OrganizationReports/>}/>
          <Route path="create-report" element={<CreateReport/>}/>
          <Route path="update-password" element={<OrganizationUpdatePassword/>}/>
      </Route>

      <Route path="/secretary-dashboard" element={<SecretaryDashboard/>}>
          <Route index element={<SecretaryMain/>}/>
          <Route path="all-requests" element={<AllRequests/>}/>
          <Route path="all-org-requests" element={<AllOrgRequests/>}/>
          <Route path="pending-requests/:user_type" element={<PendingRequests/>}/>
          <Route path="accepted-requests/:user_type" element={<AcceptedRequests/>}/>
          <Route path="nominated-requests/:user_type" element={<NominatedRequests/>}/>
          <Route path="approved-requests/:user_type" element={<ApprovedRequests/>}/>
          <Route path="ready-requests/:user_type" element={<ReadyRequests/>}/>
          <Route path="verification-requests" element={<VerificationRequests/>}/>
          <Route path="all-reports" element={<AllReports/>}/>
          <Route path="org-verification-requests" element={<OrgVerificationRequests/>}/>
          <Route path="edit-profile" element={<EditProfile/>}/>
          <Route path="update-password" element={<UpdatePassword/>}/>
          <Route path="setting" element={<Setting/>}/>
      </Route>

      <Route path="/manager-dashboard" element={<ManagerDashboard/>}>
          <Route index  element={<ManagerStats/>}/>
          <Route path="nominated-requests/:user_type" element={<ManagerNominatedRequests/>}/>
          <Route path="all-requests" element={<ManagerAllRequests/>}/>
          <Route path="all-org-requests" element={<ManagerAllOrgRequests/>}/>
          <Route path="all-reports" element={<AllReports/>}/>
          <Route path="edit-profile" element={<EditProfile/>}/>
          <Route path="update-password" element={<UpdatePassword/>}/>
      </Route>


      <Route path="/not-authorized" element={<NotAuthorized/>}/>
      <Route path="*" element={<PageNotFound/>}/>
    </Routes>
  );
}

export default App;





